module.exports = __webpack_public_path__ + "img/aniversariantes.2a78d4fa.png";